import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { Observable } from 'rxjs';
import { FraccionamientoBienCulturalInterface } from '../../herramientas/models/fracciomiento.model';
import { FracccionamientoIntegracionService } from './fraccionamiento-integracion.service ';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { FormularioIntegracionesFraccionamientoComponent } from '../../herramientas/form-integraciones-y-fraccionamiento/form-integraciones-y-fraccionamiento.component';
import { FichaRegistro } from 'app/models/fichaRegistro.model';
import { MatDialog } from '@angular/material/dialog';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'fraccionamiento-integracion',
    templateUrl: 'fraccionamiento-integracion.component.html',
    imports:[
        CommonModule,
        MatButtonModule,
        MatTableModule,
        MatIconModule,

        HasPermissionsDirective
    ]
})

export class FraccionamientoIntegracionComponent implements OnInit {
    @Input() ficha: FichaRegistro
    fraccionamientoIntegraciones$:Observable<FraccionamientoBienCulturalInterface>
    uu_id:string

    constructor(
        private fracionamientoIntegracionesService:FracccionamientoIntegracionService,
        private route:ActivatedRoute,
        private router: Router,
        public dialog: MatDialog,
    ) { 
        this.fraccionamientoIntegraciones$= this.fracionamientoIntegracionesService.fraccionamientoIntegracion$
    }

    ngOnInit() {
        this.uu_id = this.route.snapshot.paramMap.get('uu_id')!;
        this.getFracionamientoIntegraciones()
    }

    getFracionamientoIntegraciones(){
      //  this.fracionamientoIntegracionesService.getFraccionamientoIntegraciones(this.uu_id)
    }

    DetalleBienCultural(entidadUuid:string){
        this.router.navigateByUrl(`bienes-culturales/detalle/${entidadUuid}`)
    }

    integracionesFraccionamiento(fichaRegistro:FichaRegistro, formFraccionamiento:boolean){
        const dialog = this.dialog.open(FormularioIntegracionesFraccionamientoComponent, {
                panelClass: ['w-full', 'md:w-6/12'],
                maxHeight: 'calc(100vh - 4rem)',
                disableClose:true,
                data: {
                    uu_id: fichaRegistro.bienCulturalUuid,
                    noRegistro:fichaRegistro.noRegistro,
                    formFraccionamiento:formFraccionamiento,
                    descripcion: fichaRegistro.descripcion,
                    seccionBienesCulturales:fichaRegistro.seccion.tipologiaId,
                }
            })
    }
}